import { render, staticRenderFns } from "./lianxdy_config.vue?vue&type=template&id=578bba6e&scoped=true"
import script from "./lianxdy_config.vue?vue&type=script&lang=js"
export * from "./lianxdy_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578bba6e",
  null
  
)

export default component.exports